var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"id":"timesheets-approval","fluid":"","tag":"section"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[(_vm.canTimesheetApproval)?_c('idc-component-timesheets-approval',{attrs:{"can-create":_vm.canCreate,"can-edit":_vm.canEdit,"can-delete":_vm.canDelete}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }